import React from 'react';
import TranslatedComponent from '../../utils/TranslatedComponent';

export class TULogo extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var classNames = ['tuLogo'];
    if (this.props.isPrimary) {classNames.push('primaryLogo');}
    return (
      <svg className={classNames.join(' ')}  viewBox="0 0 584.7 231.2" aria-labelledby='undefeated-logo-title' role='img'>
        <title id='undefeated-logo-title'>The Undefeated Logo</title>
        <path fill="#222" d="M207.3 231.2c-11.5 0-19.5-6.6-19.5-17.7v-60h15.5v59.6c0 2.7 2.1 4.2 4 4.2s4-1.5 4-4.2v-59.6h15.5v60c.1 11.2-7.9 17.7-19.5 17.7m95.3-59.2c0-3.1-1.5-4.5-4.2-4.5h-3.8v48.9h3.8c2.7 0 4.2-1.4 4.2-4.5V172zm-2.2 58.3h-21.2v-76.7h21.2c10.8 0 17.5 6.1 17.5 16.8v43.1c0 10.7-6.7 16.8-17.5 16.8m23.1-76.7v76.7h30.4v-13.9h-15.1v-17.7h13.3V185h-13.2v-17.5h15v-13.9m4.8 0v76.7H374v-31.6h13.3V185h-13.2v-17.5h15v-13.9m4.2 0v76.7h30.4v-13.9h-15.1v-17.7h13.3V185h-13.2v-17.5h15v-13.9m24.1 16.8h1.1l3 31.5h-7.1l3-31.5zm-11.2-16.8l-10.1 76.7h15.1l2-15.3h9.7l2 15.3h15.1l-10.1-76.7h-23.7zm30 0v13.9h11.7v62.8h15.5v-62.8h11.6v-13.9m4.9 0v76.7h30.3v-13.9h-15v-17.7h13.3V185h-13.2v-17.5h14.9v-13.9m28.9 18.4c0-3.1-1.5-4.5-4.2-4.5h-3.8v48.9h3.8c2.7 0 4.2-1.4 4.2-4.5V172zm-2.3 58.3H546v-76.7h21.2c10.8 0 17.5 6.1 17.5 16.8v43.1c0 10.7-6.7 16.8-17.5 16.8m-308-.1l-11.6-38.3v38.3h-14.8v-76.7h13.9l11.5 39.6v-39.6h14.9v76.7M215.6 82.1v62.8h-15.5V82.1h-11.8V68.2h39.1v13.9m30.1 62.8v-31.6h-9.1v31.6h-15.6V68.2h15.6v31.5h9.1V68.2h15.6v76.7m6.1 0V68.2h30.3v13.9h-14.9v17.6h13.2v13.6h-13.3v17.8h15v13.8"/>
        <g fill="#222">
          <path d="M135.4 229.4c-35.3 0-52.8-24.6-52.8-65.8V0H0v164.5c0 41.2 19.7 65.8 41.1 65.8h94.3v-.9z"/>
          <path d="M93.9 163.6c0 20.4 5.4 54.6 41.5 54.6s41-34.2 41-54.6V68.2H93.9v95.4z"/>
        </g>
      </svg>
    );
  }
}

TranslatedComponent(TULogo);
export default TULogo;




// WEBPACK FOOTER //
// ./client/src/components/logos/TULogo.jsx